// extracted by mini-css-extract-plugin
module.exports = {"rightNavigation":"CarouselRight_rightNavigation__ZX2PK"};